// Copyright ©️ 2026 eVolve MEP, LLC

import { type WorkOrder, useEvolvePatch } from '@evolvemep/api-ts';

import type { EntityStatusBadgeProps, GetLabelAndColorArgs } from 'components/Mantine/EntityStatusBadge';
import { EditableStatusBadge } from 'components/Mantine/StatusEditor/EditableStatusBadge';

type Props = Omit<EntityStatusBadgeProps<'Work Order'>, keyof GetLabelAndColorArgs<'Work Order'>> & {
  workOrder: Pick<WorkOrder, 'workOrderId' | 'workOrderStatusId' | 'workOrderStateName' | 'workOrderStateId'>;
  onWorkOrderUpdated: (workOrder: WorkOrder) => void;
  editable: boolean;
};

export const EditableWorkOrderStatusBadge = ({ workOrder, onWorkOrderUpdated, ...props }: Props) => {
  const { apiCall: patchWorkOrder } = useEvolvePatch(`shop/workOrder/${workOrder.workOrderId}`);

  return (
    <EditableStatusBadge
      customStatusTypeName="Work Order"
      statusId={workOrder.workOrderStatusId ?? null}
      stateName={workOrder.workOrderStateName}
      onAssignStatus={async (workOrderStatusId) => patchWorkOrder({ workOrderStatusId }).then(onWorkOrderUpdated)}
      {...props}
    />
  );
};
